import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {IFieldInputTypeHandler} from './IFieldInputTypeHandler';
import {AbstractControl, UntypedFormGroup} from '@angular/forms';
import {FormValueModel} from '../../../../../modules/form/form/value/api/entity/formValue.model';
import {Subscription} from 'rxjs';
import {
    FormDefinitionFieldModel
} from '../../../../../modules/form/definition/field/api/entity/formDefinitionField.model';
import {
    FormFieldDefinitionOptionModel
} from "../../../../../modules/form/definition/field/api/entity/formFieldDefinitionOption.model";
import {PartnerSummaryModel} from "../../../../../modules/partner/common/api/model/partnerSummary.model";

@Component({
    template: `<p>This should never be visible</p>`
})
export abstract class AbstractFieldInputTypeHandlerComponent<Control extends AbstractControl>
    implements IFieldInputTypeHandler, OnInit, OnDestroy, OnChanges{



    public static resolveReadableValues(value: any,
                                        unit: string,
                                        options: FormFieldDefinitionOptionModel[]): Promise<FormValueReadableValue[]> {
        return Promise.resolve([]);
    }

    @Input() fieldFormGroup: UntypedFormGroup;
    @Input() partnerSummary: PartnerSummaryModel;

    // Mandatory
    @Input() formValue: FormValueModel;
    jsonControl: Control;
    subscriptions: Subscription[] = [];

    abstract buildJsonControl(formDefinitionField: FormDefinitionFieldModel): Control;
    // Return the string value that will be set as form value.
    abstract synchronizeValue(): string;
    abstract initiateForm(formValue: FormValueModel): void;

    synchronizeRuleValue(): string {
        return this.synchronizeValue();
    }

    ngOnInit() {
        // console.log('formValue', this.formValue);
        this.fieldFormGroup.removeControl(this.jsonControlName);
        this.jsonControl = this.buildJsonControl(this.formValue.fieldDefinition);
        this.fieldFormGroup.addControl(this.jsonControlName, this.jsonControl);
        this.subscriptions.push(this.jsonControl.valueChanges.subscribe(() => {
            const value = this.synchronizeValue();
            this.fieldFormGroup.get('ruleValue').setValue(this.synchronizeRuleValue());
            this.fieldFormGroup.get('value').setValue(value);
        }));
        if (this.formValue) {
            this.initiateForm(this.formValue);
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['formValue']) {
            console.log(['form value changed', this.formValue]);
            this.initiateForm(this.formValue);
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(value => value.unsubscribe());
    }


    get parentFormGroup(): UntypedFormGroup {
        return this.fieldFormGroup;
    }

    get jsonControlName(): string {
        return 'json';
    }

    get formDefinitionField(): FormDefinitionFieldModel {
        return this.formValue?.fieldDefinition;
    }

    setMeasured(measured: boolean) {
        this.fieldFormGroup?.get('measured')?.setValue(measured);
    }

    get measured() {
        return this.fieldFormGroup?.get('measured')?.value;
    }
}

export class FormValueReadableValue {
    value: string
    type: 'TEXT' | 'IMAGE' | 'DOCUMENT';

    public static ofImage(value: string):FormValueReadableValue  {
        return {
            value,
            type : 'IMAGE'
        };
    }

    public static ofDocument(value: string): FormValueReadableValue{
        return {
            value,
            type : 'DOCUMENT'
        };
    }

    public static ofText(value: string): FormValueReadableValue {
        return {
            value,
            type : 'TEXT'
        };
    }
}
